import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ptBr from './langages/ptBr'

Vue.use(VueI18n)

let locale = window.localStorage.getItem('rickelarissa_locale')

if (!locale) {
    locale = 'pt-br'
}

export default new VueI18n({
    locale: locale,
    messages: {
        ...ptBr
    }
})
